<template>
    <div class="animated fadeIn">
    
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col lg="6">
              <b-form-group label="Arrival Date:" label-cols-sm="4" label-cols-lg="3">
                <v-date-picker :formats='dateformats' v-model="searchDate" :input-props='{ class: "form-control" }' show-caps>
                </v-date-picker>
              </b-form-group>
    
            </b-col>       
            <b-col lg="6">
              <b-button variant="primary" class="pull-left" @click="search" :disabled="!searchDate">
                Search
              </b-button>
            </b-col>     
          </b-row>
        
          <b-row>
          <b-col>
             <b-button block variant="primary" @click="search">Refresh Records Manually</b-button>
          </b-col>
        </b-row>
        </b-card-body>
      </b-card>
    
      <b-card no-body>
        <b-card-body>
        <b-row>
          <b-col lg="12">
         <b-button variant="primary" class="pull-left" @click="print" :disabled="visitors.length <= 0">
          Export To CSV
        </b-button>
        </b-col>
        </b-row>
        <br/>
          <b-row>
          <b-col lg="12">
    
    
        <ag-grid-vue
                 class="ag-theme-balham"
                 id="myGrid"
                 :gridOptions="gridOptions"
                 :columnDefs="columns"
                 :rowData="visitors">
        </ag-grid-vue>
    
        </b-col>
        </b-row>
    
    
        </b-card-body>
      </b-card>
    
    
    </div>
    
    </template>
    
    <script>
    import { mapState } from 'vuex'
    import Vue from 'vue'
    import {AgGridVue} from "ag-grid-vue";
    
    export default {
      name: 'SatsangiArrivalReport',
      components: {
        AgGridVue
      },
      data: function() {
        return {
          searchDate: new Date(),          
          visitors: [],
          gridOptions : {},
          gridApi: null,
          columns : [],
          useVuex: false,
          timer: '',
          theme: 'bootstrap4',
          template: 'default'
        }
      },
      methods: {
    
      search() {
          this.visitors = []
          let params = {
            searchDate: this.formatDate(this.searchDate)            
          }
          Vue.axios.get('admin/reports/visitors-by-date', {params: params})
          .then(response => {
            this.visitors = response.data.data
            if(this.visitors.length > 0){
            this.columns = [
                      {headerName: 'Reservation Number', field: 'reservationNumber', sortable: true, filter: true},
                      {headerName: 'Card Number', field: 'cardno', sortable: true, filter: true},
                      {headerName: 'Satsangi Name', field: 'applicant_name', sortable: true, filter: true},
                      {headerName: 'Arrival Date', field: 'arrival_date', sortable: true, filter: true},
                      {headerName: 'Building Name', field: 'building'},                                                               
                  ];
            }
            else{
            this.columns = [];
            }
            this.showSuccessMsg()
          })
          .catch ( error => {
            this.showErrorMsg({message: error});
          });
        },
    
    
      print() {
         this.gridApi.exportDataAsCsv({});
      }
      },
      created () {
        this.search();       
      },
      mounted() {
        this.gridApi = this.gridOptions.api;
        this.timer = setInterval(this.search, 1800000);
    
      },
      beforeDestroy(){
       clearTimeout(this.timer);
    },
    
    }
    
    
    </script>
    